import { render, staticRenderFns } from "./simplifyAcceptanceList.vue?vue&type=template&id=6971b73d&scoped=true"
import script from "./simplifyAcceptanceList.vue?vue&type=script&lang=js"
export * from "./simplifyAcceptanceList.vue?vue&type=script&lang=js"
import style0 from "./simplifyAcceptanceList.vue?vue&type=style&index=0&id=6971b73d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6971b73d",
  null
  
)

export default component.exports